export default "__VITE_ASSET__26ae41ab__"